import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'cc-key',
  templateUrl: './key.component.html',
  styleUrls: ['./key.component.scss']
})
export class KeyComponent implements OnInit {
  @Input() character: string;
  @Input() characters: string;
  @Input() isSelected: boolean;
  @Output() keyClick: EventEmitter<string> = new EventEmitter();

  constructor() {}

  ngOnInit() {
    if (this.character === '0') {
      this.keyClick.emit('0');
    }
  }

  handleKeyClicked(character: string): void {
    this.keyClick.emit(character);
  }
}
